export default "__VITE_ASSET__Dw4uxm3K__"